import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchPartner(params) {
  return await request({
    url: ENDPOINT.HOME_PARTNER,
    method: "get",
    params,
  });
}

export async function fetchPartnerById(id) {
  return await request({
    url: `${ENDPOINT.HOME_PARTNER}/${id}/edit`,
    method: "get",
  });
}

export async function createPartner(data) {
  return await request({
    url: ENDPOINT.HOME_PARTNER,
    method: "post",
    data,
  });
}

export async function updatePartner(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_PARTNER}/${id}`,
    method: "post",
    data,
  });
}

export async function deletePartner(id) {
  return await request({
    url: `${ENDPOINT.HOME_PARTNER}/${id}`,
    method: "delete",
  });
}